import React from 'react';
import {
  PencilSquareIcon,
  TrashIcon,
  PhotoIcon,
} from '@heroicons/react/24/outline';

const STAGGER_SPAN = 24;

// Library resimlerinin "lightbox" kart grid'i. Karta tıklama düzenleme açar;
// hover'da resim yakınlaşır, kart kalkar, düzenle/sil butonları belirir.
const ImageLibraryGrid = ({ images, onEdit, onDelete }) => (
  <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4">
    {images.map((img, idx) => (
      <div
        key={img.id}
        style={{
          animationDelay: `${Math.min(idx % STAGGER_SPAN, 11) * 35}ms`,
        }}
        className="ilb-card group relative flex flex-col overflow-hidden rounded-xl border border-slate-200 bg-white shadow-sm transition-all duration-200 hover:-translate-y-0.5 hover:border-slate-300 hover:shadow-md dark:border-slate-700 dark:bg-slate-800 dark:hover:border-slate-600"
      >
        <button
          type="button"
          onClick={() => onEdit(img)}
          className="block w-full text-left"
        >
          <div className="relative aspect-square w-full overflow-hidden bg-slate-100 dark:bg-slate-900">
            {img.imagepath ? (
              <img
                src={img.imagepath}
                alt={img.name}
                loading="lazy"
                className="h-full w-full object-cover transition-transform duration-300 group-hover:scale-105"
              />
            ) : (
              <div className="flex h-full items-center justify-center text-slate-400 dark:text-slate-600">
                <PhotoIcon className="h-8 w-8" />
              </div>
            )}
            {img.folder ? (
              <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-black/75 to-transparent px-2.5 pb-1.5 pt-6">
                <span className="text-[0.6rem] font-semibold uppercase tracking-[0.12em] text-white/85">
                  {img.folder}
                </span>
              </div>
            ) : null}
          </div>
          <p className="truncate px-3 py-2.5 text-sm font-semibold text-slate-800 dark:text-slate-100">
            {img.name || '—'}
          </p>
        </button>
        <div className="absolute right-2 top-2 flex gap-1 opacity-0 transition group-hover:opacity-100">
          <button
            type="button"
            onClick={() => onEdit(img)}
            aria-label="Edit image"
            className="flex h-7 w-7 items-center justify-center rounded-md bg-white/95 text-slate-600 shadow-sm ring-1 ring-slate-200 backdrop-blur transition hover:text-blue-600 dark:bg-slate-900/90 dark:text-slate-300 dark:ring-slate-600"
          >
            <PencilSquareIcon className="h-4 w-4" />
          </button>
          <button
            type="button"
            onClick={() => onDelete(img)}
            aria-label="Delete image"
            className="flex h-7 w-7 items-center justify-center rounded-md bg-white/95 text-slate-600 shadow-sm ring-1 ring-slate-200 backdrop-blur transition hover:text-rose-600 dark:bg-slate-900/90 dark:text-slate-300 dark:ring-slate-600"
          >
            <TrashIcon className="h-4 w-4" />
          </button>
        </div>
      </div>
    ))}
  </div>
);

export default ImageLibraryGrid;
